/* ============================================================
   Sundays Galerrie — Theme JS
   Cart drawer, mobile nav, variant selection, add to cart,
   search, upsells, AJAX remove
   ============================================================ */

(function () {
  'use strict';

  /* ---- Cart Drawer ---- */
  var cartDrawer       = document.getElementById('cart-drawer');
  var cartToggle       = document.getElementById('cart-toggle');
  var cartClose        = cartDrawer && cartDrawer.querySelector('.cart-drawer__close');
  var cartOverlay      = cartDrawer && cartDrawer.querySelector('.cart-drawer__overlay');
  var headerCartCount  = document.getElementById('header-cart-count');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartToggle) cartToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartToggle) cartToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (cartToggle)  cartToggle.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      closeSearch();
    }
  });

  /* ---- Update cart count badge ---- */
  function updateCartCount(count) {
    if (!headerCartCount) return;
    headerCartCount.textContent = count;
    headerCartCount.style.display = count > 0 ? '' : 'none';
  }

  /* ---- Add to Cart (product page) ---- */
  var addToCartForm = document.getElementById('product-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var submitBtn = addToCartForm.querySelector('.add-to-cart-btn');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
        submitBtn.textContent = 'Adding...';
      }

      var formData = new FormData(addToCartForm);
      var payload  = { items: [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity') || 1) }] };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartDrawer(cart);
          openCart();
          // Success flash
          if (submitBtn) {
            submitBtn.textContent = 'Added!';
            submitBtn.classList.remove('is-loading');
            submitBtn.classList.add('is-success');
            setTimeout(function () {
              submitBtn.classList.remove('is-success');
              submitBtn.disabled = false;
              submitBtn.textContent = 'Add to Cart';
            }, 1500);
          }
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-loading');
            submitBtn.textContent = 'Add to Cart';
          }
        });
    });
  }

  /* ---- Refresh cart drawer body (full AJAX) ---- */
  function refreshCartDrawer(cart) {
    var body = document.getElementById('cart-drawer-body');
    if (!body) return;

    // Update drawer title count
    var titleEl = cartDrawer && cartDrawer.querySelector('.cart-drawer__title');
    if (titleEl) titleEl.textContent = 'Cart (' + cart.item_count + ')';

    if (cart.item_count === 0) {
      body.innerHTML =
        '<p class="cart-drawer__empty">Your cart is empty</p>' +
        '<a href="/collections/all" class="btn btn--outline cart-drawer__continue" style="display:block;text-align:center;margin-top:16px;">Continue shopping</a>';
      return;
    }

    var itemsHtml = cart.items.map(function (item, index) {
      var variantLine = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return (
        '<div class="cart-item">' +
          '<a href="' + item.url + '"><img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="80" height="80" style="object-fit:cover;"></a>' +
          '<div class="cart-item__info">' +
            '<p class="cart-item__name">' + escapeHtml(item.product_title) + '</p>' +
            (variantLine ? '<p class="cart-item__variant">' + escapeHtml(variantLine) + '</p>' : '') +
            '<p class="cart-item__price">' + formatMoney(item.final_price) + '</p>' +
            '<div class="cart-item__actions">' +
              '<div class="cart-item__qty">' +
                '<button type="button" class="cart-item__qty-btn" data-line="' + (index + 1) + '" data-action="minus" aria-label="Decrease">-</button>' +
                '<span class="cart-item__qty-val">' + item.quantity + '</span>' +
                '<button type="button" class="cart-item__qty-btn" data-line="' + (index + 1) + '" data-action="plus" aria-label="Increase">+</button>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-line="' + (index + 1) + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    // Buy 2+ Get Free Shipping upsell
    var totalQty = cart.items.reduce(function(sum, item) { return sum + item.quantity; }, 0);
    var upsellHtml = '';
    if (totalQty < 2) {
      upsellHtml =
        '<div class="cart-drawer__upsell">' +
          '<p class="cart-drawer__upsell-text">Add 1 more for <span>FREE SHIPPING</span></p>' +
        '</div>';
    }

    // Free shipping progress (unlocked at 2+ items)
    var shippingHtml = '';
    if (totalQty >= 2) {
      shippingHtml =
        '<div class="cart-drawer__shipping-progress cart-drawer__shipping-progress--done">' +
          '<p class="cart-drawer__shipping-text">You\'ve unlocked <strong>free shipping!</strong></p>' +
          '<div class="cart-drawer__progress-bar"><div class="cart-drawer__progress-fill" style="width:100%;"></div></div>' +
        '</div>';
    } else {
      var progressPct = totalQty >= 1 ? 50 : 0;
      shippingHtml =
        '<div class="cart-drawer__shipping-progress">' +
          '<p class="cart-drawer__shipping-text">' + totalQty + '/2 items — add ' + (2 - totalQty) + ' more for free shipping</p>' +
          '<div class="cart-drawer__progress-bar"><div class="cart-drawer__progress-fill" style="width:' + progressPct + '%;"></div></div>' +
        '</div>';
    }

    var footerHtml =
      '<div class="cart-drawer__footer">' +
        shippingHtml +
        '<div class="cart-drawer__subtotal">' +
          '<span>Subtotal</span>' +
          '<span>' + formatMoney(cart.total_price) + '</span>' +
        '</div>' +
        '<p class="cart-drawer__final-sale">All sales are final — no returns or exchanges</p>' +
        '<a href="/checkout" class="btn--checkout cart-drawer__checkout-btn">Checkout</a>' +
        '<a href="/cart" class="cart-drawer__view-cart">View Cart</a>' +
      '</div>';

    // Cart drawer cross-sells — fetch other available products to suggest
    var crossSellHtml = '';
    var cartProductIds = cart.items.map(function(item) { return item.product_id; });

    body.innerHTML = upsellHtml + itemsHtml + '<div id="cart-cross-sells"></div>' + footerHtml;

    // Fetch cross-sell suggestions
    if (cart.item_count > 0 && cart.item_count < 4) {
      fetch('/collections/drop-1/products.json?limit=4')
        .then(function(res) { return res.json(); })
        .then(function(data) {
          var suggestions = (data.products || []).filter(function(p) {
            return cartProductIds.indexOf(p.id) === -1 && p.variants && p.variants[0] && p.variants[0].available;
          }).slice(0, 2);

          if (suggestions.length > 0) {
            var csHtml = '<div class="cart-drawer__cross-sells">' +
              '<p class="cart-drawer__cross-sells-title">Complete Your Wall</p>' +
              suggestions.map(function(p) {
                var img = p.images && p.images[0] ? p.images[0].src : '';
                var vid = p.variants[0].id;
                var price = '$' + (parseFloat(p.variants[0].price) || 0).toFixed(2);
                return '<div class="cart-cross-sell">' +
                  '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" width="60" height="60" style="object-fit:cover;">' +
                  '<div class="cart-cross-sell__info">' +
                    '<span class="cart-cross-sell__name">' + escapeHtml(p.title) + '</span>' +
                    '<span class="cart-cross-sell__price">' + price + '</span>' +
                  '</div>' +
                  '<button type="button" class="cart-cross-sell__add" data-variant-id="' + vid + '">+ Add</button>' +
                '</div>';
              }).join('') +
            '</div>';

            var csContainer = document.getElementById('cart-cross-sells');
            if (csContainer) csContainer.innerHTML = csHtml;

            // Attach quick-add handlers
            document.querySelectorAll('.cart-cross-sell__add').forEach(function(btn) {
              btn.addEventListener('click', function() {
                var vid = parseInt(btn.getAttribute('data-variant-id'));
                btn.disabled = true;
                btn.textContent = '...';
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
                })
                .then(function() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
                .then(function(res) { return res.json(); })
                .then(function(updatedCart) {
                  updateCartCount(updatedCart.item_count);
                  refreshCartDrawer(updatedCart);
                });
              });
            });
          }
        })
        .catch(function() { /* silently fail cross-sells */ });
    }

    // Attach AJAX handlers for quantity and remove
    body.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'));
        var action = btn.getAttribute('data-action');
        var qtyEl = btn.parentNode.querySelector('.cart-item__qty-val');
        var currentQty = parseInt(qtyEl.textContent);
        var newQty = action === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);
        updateCartLine(line, newQty);
      });
    });

    body.querySelectorAll('.cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'));
        updateCartLine(line, 0);
      });
    });
  }

  function updateCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshCartDrawer(cart);
      });
  }

  /* ---- Money formatting ---- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' USD';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ---- Mobile Nav ---- */
  var mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  var mobileMenuClose  = document.getElementById('mobile-menu-close');
  var mobileNav        = document.getElementById('mobile-nav');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', openMobileNav);
  if (mobileMenuClose)  mobileMenuClose.addEventListener('click', closeMobileNav);

  /* ---- Search ---- */
  var searchToggle = document.getElementById('search-toggle');
  var searchOverlay = document.getElementById('search-overlay');
  var searchClose = document.getElementById('search-close');
  var searchInput = document.getElementById('search-input');
  var searchResults = document.getElementById('search-results');
  var searchTimer;

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) {
        if (searchResults) searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (!searchResults) return;
            var products = data.resources && data.resources.results && data.resources.results.products;
            if (!products || products.length === 0) {
              searchResults.innerHTML = '<p class="search-results__empty">No results for "' + escapeHtml(q) + '"</p>';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              var img = p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" width="60" height="60" style="object-fit:cover;">' : '';
              return '<a href="' + p.url + '" class="search-result">' +
                img +
                '<div class="search-result__info">' +
                  '<span class="search-result__title">' + escapeHtml(p.title) + '</span>' +
                  '<span class="search-result__price">' + p.price + '</span>' +
                '</div>' +
              '</a>';
            }).join('') +
            '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-results__all">View all results</a>';
          });
      }, 300);
    });
  }

  /* ---- Currency Selector Dropdown ---- */
  var currencyBtn      = document.getElementById('currency-btn');
  var currencyDropdown = document.getElementById('currency-dropdown');

  if (currencyBtn && currencyDropdown) {
    currencyBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = currencyDropdown.classList.contains('is-open');
      currencyDropdown.classList.toggle('is-open', !isOpen);
      currencyBtn.setAttribute('aria-expanded', String(!isOpen));
      currencyDropdown.setAttribute('aria-hidden', String(isOpen));
    });

    currencyDropdown.querySelectorAll('.currency-selector__option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('form').submit();
      });
    });

    document.addEventListener('click', function () {
      currencyDropdown.classList.remove('is-open');
      currencyBtn.setAttribute('aria-expanded', 'false');
      currencyDropdown.setAttribute('aria-hidden', 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        currencyDropdown.classList.remove('is-open');
        currencyBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- Sticky transparent header: add .is-scrolled after 10px ---- */
  var headerEl = document.querySelector('.header');
  var SCROLL_THRESHOLD = 10;

  function updateHeaderScrollState() {
    if (!headerEl) return;
    if (window.scrollY > SCROLL_THRESHOLD) {
      headerEl.classList.add('is-scrolled');
    } else {
      headerEl.classList.remove('is-scrolled');
    }
  }

  window.addEventListener('scroll', updateHeaderScrollState, { passive: true });
  updateHeaderScrollState();

  /* ---- Scroll-aware header (dark / light sections) ---- */
  function updateHeaderScheme() {
    if (!headerEl) return;
    var headerBottom = headerEl.getBoundingClientRect().bottom;
    var scheme = 'dark';

    document.querySelectorAll('.section--light, .section--dark').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top <= headerBottom && rect.bottom > 0) {
        scheme = el.classList.contains('section--light') ? 'light' : 'dark';
      }
    });

    headerEl.setAttribute('data-scheme', scheme);
  }

  window.addEventListener('scroll', updateHeaderScheme, { passive: true });
  updateHeaderScheme();

  /* ---- Variant Selector (product page) ---- */
  var variantBtns = document.querySelectorAll('.variant-btn');
  var variantInput = document.getElementById('variant-id');

  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      variantBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      if (variantInput) variantInput.value = btn.getAttribute('data-variant-id');

      var price    = btn.getAttribute('data-price');
      var compare  = btn.getAttribute('data-compare-price');
      var priceEl  = document.getElementById('product-price');
      var compareEl= document.getElementById('product-compare-price');
      var addBtn   = document.querySelector('.add-to-cart-btn');

      if (priceEl && price) priceEl.textContent = formatMoney(parseInt(price));
      if (compareEl) {
        compareEl.style.display = compare && parseInt(compare) > parseInt(price) ? 'inline' : 'none';
        if (compare) compareEl.textContent = formatMoney(parseInt(compare));
      }

      var available = btn.getAttribute('data-available') !== 'false';
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    });
  });

  /* ---- Initial cart load for AJAX remove on server-rendered items ---- */
  var initialRemoveForms = document.querySelectorAll('.cart-drawer__body .cart-item__remove');
  if (initialRemoveForms.length) {
    initialRemoveForms.forEach(function (btn) {
      var form = btn.closest('form');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var fd = new FormData(form);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line: parseInt(fd.get('line')), quantity: 0 })
          })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              refreshCartDrawer(cart);
            });
        });
      }
    });
  }

})();
